export default "__VITE_ASSET__CZhPD0d3__"